export default class ResourceEnums {
  
  constructor( api ) {
    this.api = api
    this.connect = api.child( 'resourceEnum' )
  }

  // List all enums
  list( options ) {
    return this.connect.get( options )
  }

  // add enum
  create( type, data ) {
    return this.connect.child( type ).post( data )
  }

  deleteAll( ) {
    return this.connect.delete( )
  }
}
